export default function CartLoader({ className }) {
  return (
    <div
      className={`animate-pulse border-gray-300 bg-gray-300 flex justify-between px-6 py-4 rounded-lg h-[100vh] ${className} `}
    ></div>
  );
}
